import { useCookies } from "react-cookie"

export const useAuthenticated = () => {
    const [cookies] = useCookies(['b_t']);

    const token = cookies.b_t || '';
    return !!token
}